import { object, string } from 'yup';

export default object().shape({
    securityCode:
        string()
            .required('REQUIRED')
            .min(4)
});
